let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cytEf")).then(() => parcelRequire('ivaka'));